<template>
    <div class="card text-center">
        <div class="card-body">
            <div class="row" v-if="actions.length>1">
                <div class="col">
                    <div class="row no-gutters form-group btn-group-toggle-city main">
                        <div class="col-6" :for="`action-${btn.id}`" v-for="(btn) in actions" :key="`action-${btn.id}`">
                        <label class="btn btn-sm btn-block z-depth-0" :class="{'active': btn.id == action}">
                            <input type="radio" name="toogle-action" :id="'action-'+btn.id" :value="btn.id" v-model="action" autocomplete="off">
                            <span class="inline-not-truncate">{{ btn.name }}</span>
                        </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="enableDraw" v-show="isActionDraw">
                <div class="col-12">
                    <DrawInteraction
                        v-if="map != null"
                        :id="idPanel"
                        v-model="draw.features"
                        :show="show"
                        :isActive="show"
                        :moduleCode="moduleCode"
                        :mapClass="map"
                        :minFeatures="minFeatures"
                        :maxFeatures="numberMaxFeatures"
                        :drawTypes="filteredDrawTypes"
                        :startDefaultControl="startDefaultControl"
                        :enableModify="true"
                        :showSelect="true"
                        :showClear="true"
                        :showStaticHelp="false">
                    </DrawInteraction>
                </div>
            </div>
            <div class="row" v-if="isEnableImport" v-show="isActionImport">
                <div class="col-12">
                    <UploadGeofiles
                        :disabled="isLimitFeatures"
                        :msgClass="uploadMsgClass"
                        :id="`upload-${idPanel}`"
                        :titleCtrl="''"
                        :url="url.togeojson"
                        :maxFeatures="numberMaxFeatures"
                        :maxFiles="numberMaxFeatures"
                        :propertyNameFilter="propertyNameFilter"
                        :propertyBoundaryFilterTitle="propertyBoundaryFilterTitle"
                        :propertyBoundaryFilter="propertyBoundaryFilter"
                        :maxFeaturesBoundary="numberMaxFeatures"
                        @uploaded="onUploaded"
                    >
                    </UploadGeofiles>
                </div>
            </div>
            <div class="row" v-if="fnHasError('features')">
                <div class="col">
                    <div class="city-form-group">
                        <input type="hidden" name="features" v-model="draw.features" v-validate="rulesDraw" />
                        <small class="invalid-feedback"
                            :class="[fnHasError('features') ? 'd-block' : '']">
                            {{ fnFirstError('features') }}
                        </small>
                    </div>
                </div>
            </div>

        </div>
        <div class="card-footer text-muted">
            <div class="btn-group w-100" role="group">
                <button
                    type="button"
                    @click.prevent="onCancel"
                    class="btn btn-outline-delete btn-add-feature btn-block text-nowrap">
                    {{ txtCancel }}
                </button>
                <button
                    type="button"
                    :disabled="!isLimitFeatures"
                    @click.prevent="onConfirm"
                    class="btn btn-main btn-add-feature btn-block text-nowrap">
                    {{ txtConfirm }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import ValidateMixin from '@/app/shared/mixins/ValidateMixin';
    import MessageMixin from '@/app/shared/mixins/MessageMixin';
    import { extend as extendExtent } from 'ol/extent';
    import { GeoJSON } from 'ol/format';

    let lists = {
        loaded: false,
        formats: [],
    };

    export default {
        mixins: [
            ValidateMixin,
            MessageMixin,
        ],
        components:{
            DrawInteraction: () => import(/* webpackChunkName: "draw-interaction" */ '@/components/maps/interactions/DrawInteraction'),
            UploadGeofiles: () => import(/* webpackChunkName: "upload-geofiles" */ '@/app/shared/components/maps/elements/UploadGeoFiles'),
        },
        props: {
            idPanel: {
                type: String,
                required: true,
            },
            baseTranslateID: {
                type: String,
                default: null,
            },
            moduleCode: {
                type: String,
                default: null,
            },
            show: {
                type: Boolean,
                default: true,
            },
            map: {
                type: Object,
                default: () => {},
            },
            panelCfg: {
                type: Object,
                default: () => {},
            },
            url: {
                type: Object,
                default: () => {},
            },
            acl: {
                type: Object,
                default: () => {},
            },
            drawTypes: {
                type: [String, Array],
                default: () => ['point', 'line', 'polygon'],
                validator: function (prop) {
                    let valid = [
                        'point',
                        // 'text',
                        'line',
                        'freehand',
                        'freehand-shape',
                        'ellipse',
                        'circle',
                        'polygon',
                        'rectangle',
                        'square',
                    ];
                    if(typeof prop === "string"){
                        return valid.includes(prop);
                    }
                    return prop.every(e => valid.includes(e));
                }
            },
            enableDraw: {
                type: Boolean,
                default: true,
            },
            enableImport: {
                type: Boolean,
                default: true,
            },
            uploadMsgClass: {
                type: String,
                default: null,
            },

        },
        data() {
            return {
                action: null,
                draw: {
                    features: [],
                },
            }
        },
        mounted() {
            this.initialize();
        },
        beforeDestroy() {
            this.reset();
        },
        computed: {
            translateID() {
                return `${this.baseTranslateID ?? this.idPanel}`
            },
            geometryCfg(){
                return this.panelCfg?.geometry ?? {};
            },
            geometryUploadCfg(){
                return this.geometryCfg?.upload ?? {};
            },
            minFeatures(){
                return this.geometryCfg.minfeatures || 1;
            },
            maxFeatures(){
                return this.geometryCfg.maxfeatures || 1;
            },
            numberMaxFeatures(){
                return Math.max(this.maxFeatures, this.minFeatures);
            },
            startDefaultControl(){
                return this.geometryCfg.startDefaultControl ?? false;
            },
            geometryTypes(){
                return (this.geometryCfg.geometry_types ?? []).map(x => x.toLowerCase());
            },
            filteredDrawTypes(){
                return this.drawTypes.filter(d => this.geometryTypes &&  this.geometryTypes.length ? this.geometryTypes.includes(d) : true);
            },
            txtAddTitleButton(){
                return this.$t(this.title);
            },
            txtCancel(){
                return this.$t(this.panelCfg?.cancelTitle ?? `${this.translateID}.buttons.cancel`);
            },
            txtConfirm(){
                return this.$t(this.panelCfg?.confirmTitle ?? `${this.translateID}.buttons.confirm`);
            },
            features(){
                return this.draw.features ?? [];
            },
            isLimitFeatures(){
                return this.numberMaxFeatures <= this.features.length
            },
            isEnableDraw(){
                return !!this.geometryCfg?.draw?.status && this.enableDraw;
            },
            isEnableImport(){
                return !!this.geometryCfg?.upload?.status && this.enableImport;
            },
            actions() {
                let actions = [];
                if(this.isEnableDraw){
                    actions.push({'id': 'draw', 'name': this.$t(`${this.idPanel}.actions.draw`)});
                }
                if(this.isEnableImport){
                    actions.push({'id': 'import', 'name': this.$t(`${this.idPanel}.actions.import`)});
                }
                return actions;
            },
            initialAction() {
                return this.isEnableDraw ? 'draw' : (this.isEnableImport ? 'import' : null);
            },
            isActionDraw(){
                return this.action == 'draw';
            },
            isActionImport(){
                return this.action == 'import';
            },
            rulesDraw(){
                let rules = {
                    'required': this.minFeatures>0,
                };
                if(this.numberMaxFeatures == this.minFeatures) {
                    rules['numElements'] = this.numberMaxFeatures;
                }else{
                    rules['maxElements'] = this.numberMaxFeatures;
                    rules['minElements'] = this.minFeatures;
                }
                return rules;
            },
            propertyNameFilter(){
                let props = this.geometryUploadCfg?.filterProperty ?? '';
                if(typeof props === 'string' || props instanceof String){
                    props = props.split(',').map(item => item.trim()).filter(function(e){ return e === 0 || e });
                }
                return props ? props : [];
            },
            propertyBoundaryFilter(){
                let props = this.geometryUploadCfg?.filterBoundary ?? '';
                if(typeof props === 'string' || props instanceof String){
                    props = props.split(',').map(item => item.trim()).filter(function(e){ return e === 0 || e });
                }
                return props ? props : [];
            },
            propertyBoundaryFilterTitle(){
                return this.$t(this.geometryUploadCfg.filterBoundaryTitle);
            },
            propertyClaimFilter(){
                let props = this.geometryUploadCfg?.filterClaim ?? '';
                if(typeof props === 'string' || props instanceof String){
                    props = props.split(',').map(item => item.trim()).filter(function(e){ return e === 0 || e });
                }
                return props ? props : [];
            },
        },
        methods: {
            initialize() {
                this.reset();
                this.action = this.initialAction;
                this.loadLists();
            },
            reset(){
                Object.assign(this.$data.draw, this.$options.data().draw);
                this.action = null;
            },
            onConfirm() {
                this.$emit('onConfirm', {features: this.draw.features});
            },
            onCancel() {
                this.reset();
                this.$emit('onCancel');
            },
            async loadLists() {
                let url = this.url.formats;
                if (url && this.isEnableImport) {
                    if(!lists.loaded){
                        return await this.$http.get(url)
                            .then(({data}) =>
                            {
                                lists.formats =  data.data;
                                lists.loaded = true;
                                return true;
                            })
                            .catch(error => {
                                lists.loaded = false;
                                this.showHttpError(error);
                                return false;
                            });
                    }else{
                        return Promise.resolve(true);
                    }
                }
                return Promise.resolve(null);
            },
            onUploaded(geojson){
                if(geojson){
                    let features = this.draw.features;
                    let initNumFeatures = features.length;
                    let mapDataProjection = this.map.getProjection();
                    let availableGeomTypes = this.filteredDrawTypes.map(t => t.toLowerCase());
                    let propsNameFilter = this.propertyNameFilter ? this.propertyNameFilter.map(p => p.toLowerCase()) : [];
                    let propertyClaimFilter = this.propertyClaimFilter ? this.propertyClaimFilter.map(p => p.toLowerCase()) : [];
                    let propertyBoundaryFilter = this.propertyBoundaryFilter ? this.propertyBoundaryFilter.map(p => p.toLowerCase()) : [];
                    let format = new GeoJSON({'dataProjection': mapDataProjection.getCode()});
                    geojson.every((geojsonObject, index) => {
                        try {
                            let options = {
                                'featureProjection': mapDataProjection.getCode(),
                            };
                            let dataProjection = format.readProjection(geojsonObject);
                            if(dataProjection){
                                let code = dataProjection.getCode();
                                code = code.indexOf('def:crs:')>-1 ? code.split('def:crs:')[1] : code;
                                options['dataProjection'] = code.endsWith(":CRS84") ? 'EPSG:4326' : code;
                            }

                            let _features = format.readFeatures(geojsonObject, options);
                            _features.every((feature) => {
                                let clonedFeature = feature.clone();
                                let geometry = clonedFeature.getGeometry();
                                if(geometry && availableGeomTypes.includes(geometry.getType().toLowerCase())) {
                                    let properties = feature.getProperties();
                                    let propLayer = propsNameFilter ? feature.get(Object.keys(properties)
                                        .find(key => propsNameFilter.includes(key.toLowerCase()))) : false;
                                    if(propLayer){
                                        propLayer = propLayer.trim().toLowerCase();
                                        if(([...propertyClaimFilter, ...propertyBoundaryFilter].includes(propLayer)
                                            || propertyBoundaryFilter.length == 0)) {

                                            clonedFeature.set('type', propertyClaimFilter.includes(propLayer) ? this.draw.prop_claim :
                                                (propertyBoundaryFilter.includes(propLayer) || propertyBoundaryFilter.length == 0) ? this.draw.prop_boundary : this.draw.prop_boundary, true);

                                            properties = clonedFeature.getProperties();
                                            for (let k in properties) {
                                                if (k != 'geometry') {
                                                    clonedFeature.unset(k, true);
                                                }
                                            }
                                            if(propertyBoundaryFilter.includes(propLayer) || propertyBoundaryFilter.length == 0){
                                                let idxBoundary = features.findIndex(f => f.get('type')?f.get('type')==this.draw.prop_boundary:false);
                                                if(idxBoundary>-1){
                                                    features.splice(idxBoundary, 1);
                                                    features.splice(idxBoundary, 0, clonedFeature);
                                                }else{
                                                    if(!this.isLimitFeatures){
                                                        features.unshift(clonedFeature);
                                                    }
                                                }
                                            }else{
                                                if(!this.isLimitFeatures){
                                                    features.push(clonedFeature);
                                                }
                                            }
                                        }
                                    }else if(!propsNameFilter || propsNameFilter && propsNameFilter.length == 0){
                                        if(!this.isLimitFeatures){
                                            features.push(clonedFeature);
                                        }
                                    }
                                    return true;
                                }
                                return false;
                            });
                        }
                        catch(err) {
                            this.showError(err);
                        }
                        return true;
                    });

                    if(features.length == 0) {
                        this.showWarning(this.$t(`${this.idPanel}.msg.error.upload`));
                        return;
                    }
                    if(initNumFeatures != features.length){
                        this.zoomToFeatures(features);
                    }
                }
            },
            zoomToFeatures(features){
                let viewExtent = null;
                features.forEach((feat, idx) => {
                    let fExtent = feat.getGeometry().getExtent();
                    if(viewExtent){
                        extendExtent(viewExtent, fExtent);
                    }else{
                        viewExtent = fExtent;
                    }
                });
                if(viewExtent){
                    this.map.zoomToExtent(viewExtent);
                }
            },
        }
    }

</script>

<style lang="scss" scoped>
@import "@styles/_mixins.scss";
.card-footer {
    .btn-group {
        .btn {
            margin: 0;
        }
    }
}
.card {
    .card-body {
        padding: .5rem;
        @include sm {
            padding: .85rem;
        }
    }

    .card-footer {
        padding: .5rem;
        @include sm {
            padding: .85rem;
        }
    }
}
</style>